var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.226562,
    y: 0.613525,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.22656 18.6135C9.22656 15.0184 9.22656 13.2208 10.0833 11.9261C10.4658 11.3479 10.961 10.8528 11.5391 10.4702C12.8339 9.61353 14.6314 9.61353 18.2266 9.61353C21.8217 9.61353 23.6193 9.61353 24.914 10.4702C25.4922 10.8528 25.9873 11.3479 26.3699 11.9261C27.2266 13.2208 27.2266 15.0184 27.2266 18.6135C27.2266 22.2087 27.2266 24.0062 26.3699 25.301C25.9873 25.8791 25.4922 26.3743 24.914 26.7568C23.6193 27.6135 21.8217 27.6135 18.2266 27.6135C14.6314 27.6135 12.8339 27.6135 11.5391 26.7568C10.961 26.3743 10.4658 25.8791 10.0833 25.301C9.22656 24.0062 9.22656 22.2087 9.22656 18.6135ZM22.8858 18.6138C22.8858 21.1871 20.7997 23.2732 18.2264 23.2732C15.6531 23.2732 13.567 21.1871 13.567 18.6138C13.567 16.0404 15.6531 13.9543 18.2264 13.9543C20.7997 13.9543 22.8858 16.0404 22.8858 18.6138ZM18.2264 21.6968C19.9291 21.6968 21.3094 20.3164 21.3094 18.6138C21.3094 16.9111 19.9291 15.5307 18.2264 15.5307C16.5237 15.5307 15.1434 16.9111 15.1434 18.6138C15.1434 20.3164 16.5237 21.6968 18.2264 21.6968ZM23.0698 14.8151C23.6745 14.8151 24.1647 14.3249 24.1647 13.7203C24.1647 13.1156 23.6745 12.6254 23.0698 12.6254C22.4652 12.6254 21.975 13.1156 21.975 13.7203C21.975 14.3249 22.4652 14.8151 23.0698 14.8151Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaDark);
export default __webpack_public_path__ + "static/media/InstaDark.c215eb236c6d7bf37cdf65d7d96eb2a5.svg";
export { ForwardRef as ReactComponent };